module.exports = __webpack_public_path__ + "media/assets/img/lock-9a41f1d582b34f10ae0c1a25c0a09609.jpeg";